import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('domainListTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowListAttr: '@',
      allowList: '@',
      selectedOptions: '<',
      sharing: '<',
      demandPartnerPermissionIds: '<',
      demandPartnerPermissionsInputId: '<'
    },
    template: require('../templates/domainListTargeting.html'),
    controllerAs: '$domainListTargetingCtrl',
    controller: [function() {
      this.allowlistButtonOptions = componentHelper.allowlistOptions();
      this.shareButtonOptions = componentHelper.attributeEnabledMappings();

      this.shareButtonTooltip = function(val) {
        if (val) {
          return 'Allow DC partner to view domains on domain list';
        }
      };
    }]
});
